import { Grid } from "@mui/material";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useRuleResourceContext } from "../../../contexts/RuleResourceContext";
import { useToast } from "../../../services/utils";
import ViewResourceData from "./ViewResourceData";
import ReRunEditRuleExecutionTab from "../../Rules/ReRun/ReRunEditRuleExecutionTab";
import { IconBtnEditBase } from "../../../common/utils/icons";

interface ValidateAdditionalResourceProps {
  additionalResource: any;
  linkedServicesData: any;
  connectionKeysData?: any;
  // fileProcessingData: any;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  fileStreamIndex: any;
  resource_id: number | null | undefined;
  resourcesData: any;
  setResourcesData: Dispatch<SetStateAction<any>>;
  isFromQueryExecution?: boolean;
}
const ValidateReRunAdditionalResource = ({
  additionalResource,
  linkedServicesData,
  connectionKeysData,
  // fileProcessingData,
  setIsLoading,
  fileStreamIndex,
  resource_id,
  resourcesData,
  setResourcesData,
  isFromQueryExecution = false,
}: ValidateAdditionalResourceProps) => {
  const { isResourceEdit, setIsResourceEdit, fetchedAllConnectionKeys } =
    useRuleResourceContext();
  const [selectSystemId, setSelectSystemId] = useState<number>(0);
  const [resourceId, setResourceId] = useState(0);
  const { showToast } = useToast();

  // Use the passed connectionKeysData instead of fetching separately
  const additionalConnectionKeyData = connectionKeysData || [];
  // const { isEditAdditionalResource, setIsEditAdditionalResource } =
  //   useResourceContext();
  useEffect(() => {
    //setSelectSystemId(additionalResource?.linked_service_id);
    if (additionalResource?.aggregation_type === "aggregated") {
      setResourceId(additionalResource?.resource_id);
    }
  }, [additionalResource, linkedServicesData]);

  useEffect(() => {
    // Extract system_id from the selected connection key, following the same pattern as child components
    const connectionKeyId = additionalResource?.connection_key;
    if (connectionKeyId && fetchedAllConnectionKeys?.length > 0) {
      const connectionKey = fetchedAllConnectionKeys.find(
        (ck: any) => ck.id === connectionKeyId
      );

      if (connectionKey?.system_id && connectionKey.system_id > 0) {
        setSelectSystemId(connectionKey.system_id);
      }
    } else if (
      additionalResource?.system_id &&
      additionalResource.system_id > 0
    ) {
      setSelectSystemId(additionalResource.system_id);
    }
  }, [fetchedAllConnectionKeys, additionalResource]);

  return (
    <>
      {isResourceEdit === "additionalResource" ? (
        <ReRunEditRuleExecutionTab
          resourceData={additionalResource}
          resourcesData={resourcesData}
          setIsLoading={setIsLoading}
          setResourcesData={setResourcesData}
          linkedServicesData={linkedServicesData}
          connectionKeysData={additionalConnectionKeyData}
          setSelectSystemId={setSelectSystemId}
          isAggregatedBaseResource={false}
          aggregatedResourceId={resourceId}
          fileStreamIndex={fileStreamIndex}
          isAdditionalResource={true}
          resource_id={resource_id}
          isFromRuleExecution={false}
          isFromQueryExecution={isFromQueryExecution}
        />
      ) : (
        <Grid container rowSpacing={2.5} columnSpacing={4}>
          <ViewResourceData
            resourceData={additionalResource}
            linkedServicesData={linkedServicesData}
            connectionKeysData={additionalConnectionKeyData}
            // fileProcessingData={fileProcessingData}
            setIsLoading={setIsLoading}
            showAdditionalResource={false}
            resource_id={resource_id}
            resourcesData={resourcesData}
            setResourcesData={setResourcesData}
            resourceCategory={"additionalResource"}
          />
        </Grid>
      )}
      {isResourceEdit !== "additionalResource" && (
        <Grid
          item
          xs={12}
          sm={12}
          md
          sx={{ justifyContent: "flex-end", display: "flex" }}
        >
          <button
            className="btn-nostyle icon-btn-edit"
            onClick={() => {
              if (isResourceEdit === "") {
                setIsResourceEdit("additionalResource");
              } else {
                showToast("Please save changes first!!", "warning");
              }
            }}
          >
            <IconBtnEditBase ariaLabel="Edit additional resource" />
          </button>
        </Grid>
      )}
    </>
  );
};

export default ValidateReRunAdditionalResource;
